/* eslint-disable no-case-declarations */
import React, { useEffect, useState } from 'react';

import { InputText, Spinner } from 'triider-components';

import axios from 'axios';

import { getCityByNameAndState } from 'services/api/locals';
import { getStateByUF, getIdByUf } from 'utils/states';
import SEGMENTS from '../../../../../../helpers/segment';
import {
  Content, ContentText, SelectButtons, Button, PaymentInfo, BoxLoader, TextAreaStyled,
} from './styles';

const PaymentInfoStep = ({
  taskDetail,
  triiderUser,
  billingType,
  fields,
  setBillingType,
  setFields,
  isLoading,
  stepInfo,
}) => {
  const IMOB_SEGMENT = triiderUser.company.segment_id === null || SEGMENTS.IMOBILIARIA === triiderUser.company.segment_id;
  const billingTypes = [
    {
      text: IMOB_SEGMENT ? 'Imobiliária' : 'Empresa',
    },
    {
      text: 'Proprietário',
      hide: !IMOB_SEGMENT,
    },
    {
      text: 'Inquilino',
      hide: !taskDetail.from_tenant || !IMOB_SEGMENT,
    },
    {
      text: 'Outro',
    },
  ];

  const [disabledInputForBuilding, setDisabledInputForBuilding] = useState(false);

  const getIdOfCity = async (nameCity, uf) => {
    const stateID = getIdByUf(uf);
    const response = await getCityByNameAndState(stateID, nameCity);
    if (response.success) {
      const { city } = response;
      return city.id;
    }
    return '';
  };

  const changeField = ({ target: { name, value } }) => {
    setFields({ ...fields, [name]: value });
  };

  const searchCEP = async (cep) => {
    const cepReplace = cep.replace(/\D/g, '');
    const { data } = await axios.get(`https://viacep.com.br/ws/${cepReplace}/json/`);
    if (!data.erro) {
      setFields({
        name: fields.name || '',
        email: fields.email || '',
        cnpj: fields.cnpj || '',
        cpf: fields.cpf || '',
        address: data.logradouro || '',
        address_details: data.complemento || '',
        district: data.bairro || '',
        city_name: data.localidade || '',
        city_id: await getIdOfCity(data.localidade, data.uf) || '',
        cep: data.cep ? data.cep.replace('-', '') : '',
        state_id: getIdByUf(data.uf) || '',
        state_name: getStateByUF(data.uf) || '',
        state_initials: data.uf || '',
        number: fields.number || '',
      });
    }
  };

  const setCPFMask = (value) => {
    let valueReplace = value;
    if (value) {
      valueReplace = valueReplace.replace(/(\d{3})(\d)/, '$1.$2');
      valueReplace = valueReplace.replace(/(\d{3})(\d)/, '$1.$2');
      valueReplace = valueReplace.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    }
    return valueReplace;
  };

  const setCNPJMask = (value) => {
    let valueReplace = value;
    if (value) {
      valueReplace = valueReplace.replace(/^(\d{2})(\d)/, '$1.$2');
      valueReplace = valueReplace.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      valueReplace = valueReplace.replace(/\.(\d{3})(\d)/, '.$1/$2');
      valueReplace = valueReplace.replace(/(\d{4})(\d)/, '$1-$2');
    }
    return valueReplace;
  };

  const setCEPMask = (value) => {
    let valueReplace = value;
    if (value) {
      valueReplace = valueReplace.replace(/\D/g, '');
      valueReplace = valueReplace.replace(/^(\d{2})(\d)/, '$1.$2');
      valueReplace = valueReplace.replace(/\.(\d{3})(\d)/, '.$1-$2');
    }
    return valueReplace;
  };

  const changeFieldCpfCnpj = ({ target: { value } }) => {
    const valueReplace = value.replace(/\D/g, '');
    if (valueReplace.length <= 11) {
      setFields({ ...fields, cpf: valueReplace, cnpj: '' });
    } else if (valueReplace.length >= 12 && valueReplace.length <= 14) {
      setFields({ ...fields, cnpj: valueReplace, cpf: '' });
    }
  };

  const changeFieldCep = ({ target: { value } }) => {
    const valueReplace = value.replace(/\D/g, '');
    if (valueReplace.length <= 8) {
      setFields({ ...fields, cep: valueReplace });
    }
  };

  const selectBillingType = (type, cameUseEffect = false) => {
    setBillingType(type);

    switch (type) {
      case 'Imobiliária':
      case 'Empresa':
        const loadPage = taskDetail.billing_info && cameUseEffect ? taskDetail.billing_info : {
          name: triiderUser.company.name || '',
          email: triiderUser.user.email || '',
          cnpj: triiderUser.company.cnpj || '',
          cpf: '',
          address: triiderUser.company.billing_address
            ? triiderUser.company.billing_address.address : '',
          address_details: triiderUser.company.billing_address
            ? (triiderUser.company.billing_address.address_details !== null
              ? triiderUser.company.billing_address.address_details : '') : '',
          district: triiderUser.company.billing_address
            ? triiderUser.company.billing_address.district : '',
          city_name: triiderUser.company.billing_address
            ? triiderUser.company.billing_address.city_name : '',
          city_id: triiderUser.company.billing_address
            ? triiderUser.company.billing_address.city_id : '',
          cep: triiderUser.company.billing_address
            ? triiderUser.company.billing_address.cep : '',
          state_name: triiderUser.company.billing_address
            ? triiderUser.company.billing_address.state_name : '',
          state_id: triiderUser.company.billing_address
            ? triiderUser.company.billing_address.state_id : '',
          state_initials: triiderUser.company.billing_address
            ? triiderUser.company.billing_address.state_initials : '',
          number: triiderUser.company.billing_address
            ? triiderUser.company.billing_address.number : '',
        };
        if (triiderUser.company.billing_address) {
          setDisabledInputForBuilding(true);
        }
        setFields({
          name: loadPage.name,
          email: loadPage.email,
          cnpj: loadPage.cnpj,
          cpf: loadPage.cpf,
          address: loadPage.address,
          address_details: loadPage.address_details,
          district: loadPage.district,
          city_name: loadPage.city_name,
          city_id: loadPage.city_id,
          cep: loadPage.cep,
          state_name: loadPage.state_name,
          state_id: loadPage.state_id,
          state_initials: loadPage.state_initials,
          number: loadPage.number,
        });
        break;
      case 'Proprietário':
        const { address_owner } = taskDetail.taskAddress;
        const loadPageP = taskDetail.billing_info && cameUseEffect ? taskDetail.billing_info : {
          name: address_owner && address_owner.name ? address_owner.name : '',
          email: address_owner && address_owner.email ? address_owner.email : '',
          cnpj: address_owner && address_owner.cnpj ? address_owner.cnpj : '',
          cpf: address_owner && address_owner.cpf ? address_owner.cpf : '',
          cep: taskDetail.taskAddress.id ? taskDetail.taskAddress.cep : '',
          number: taskDetail.taskAddress.id ? taskDetail.taskAddress.number : '',
          state_initials: taskDetail.taskAddress.id ? taskDetail.taskAddress.state_initials : '',
          state_id: taskDetail.taskAddress.id ? taskDetail.taskAddress.state_id : '',
          state_name: taskDetail.taskAddress.id ? taskDetail.taskAddress.state_name : '',
          district: taskDetail.taskAddress.id ? taskDetail.taskAddress.district : '',
          city_name: taskDetail.taskAddress.id ? taskDetail.taskAddress.city_name : '',
          city_id: taskDetail.taskAddress.id ? taskDetail.taskAddress.city_id : '',
          address: taskDetail.taskAddress.id ? taskDetail.taskAddress.address : '',
          address_details: taskDetail.taskAddress.id ? taskDetail.taskAddress.address_details : '',
        };
        setDisabledInputForBuilding(false);
        setFields({
          name: loadPageP.name,
          email: loadPageP.email,
          cnpj: loadPageP.cnpj,
          cpf: loadPageP.cpf,
          address: loadPageP.address,
          address_details: loadPageP.address_details,
          district: loadPageP.district,
          city_name: loadPageP.city_name,
          city_id: loadPageP.city_id,
          cep: loadPageP.cep,
          state_name: loadPageP.state_name,
          state_id: loadPageP.state_id,
          state_initials: loadPageP.state_initials,
          number: loadPageP.number,
        });
        break;
      case 'Inquilino':
        const isTenatnt = taskDetail.billing_info && taskDetail.billing_info.from_type === 'Inquilino';
        const loadPageI = billing_info && cameUseEffect ? billing_info : {
          name: isTenatnt ? taskDetail.billing_info.name : taskDetail.user_name,
          email: isTenatnt ? taskDetail.billing_info.email : taskDetail.user_email,
          cnpj: isTenatnt ? taskDetail.billing_info.cnpj : '',
          cpf: isTenatnt ? taskDetail.billing_info.cpf : '',
          cep: isTenatnt && taskDetail.billing_info.cep ? taskDetail.billing_info.cep : '',
          number: isTenatnt && taskDetail.billing_info.number ? taskDetail.billing_info.number : '',
          state_initials: '',
          state_id: '',
          state_name: '',
          district: '',
          city_name: '',
          city_id: '',
          address: '',
          address_details: '',
        };
        setDisabledInputForBuilding(false);
        setFields({
          name: loadPageI.name,
          email: loadPageI.email,
          cnpj: loadPageI.cnpj,
          cpf: loadPageI.cpf,
          address: loadPageI.address,
          address_details: loadPageI.address_details,
          district: loadPageI.district,
          city_name: loadPageI.city_name,
          city_id: loadPageI.city_id,
          cep: loadPageI.cep,
          state_name: loadPageI.state_name,
          state_id: loadPageI.state_id,
          state_initials: loadPageI.state_initials,
          number: loadPageI.number,
        });
        break;

      default:

        const loadPageD = taskDetail.billing_info && cameUseEffect ? taskDetail.billing_info : {
          name: '',
          email: '',
          cnpj: '',
          cpf: '',
          cep: '',
          number: '',
          state_initials: '',
          state_id: '',
          state_name: '',
          district: '',
          city_name: '',
          city_id: '',
          address: '',
          address_details: '',
        };
        setDisabledInputForBuilding(false);
        setFields({
          name: loadPageD.name,
          email: loadPageD.email,
          cnpj: loadPageD.cnpj,
          cpf: loadPageD.cpf,
          address: loadPageD.address,
          address_details: loadPageD.address_details,
          district: loadPageD.district,
          city_name: loadPageD.city_name,
          city_id: loadPageD.city_id,
          cep: loadPageD.cep,
          state_name: loadPageD.state_name,
          state_id: loadPageD.state_id,
          state_initials: loadPageD.state_initials,
          number: loadPageD.number,
        });
        break;
    }
  };

  useEffect(() => {
    selectBillingType(billingType, true);
  }, []);

  return (
    <Content isLoading={isLoading}>
      {isLoading ? (
        <BoxLoader>
          <Spinner size="larger" />
        </BoxLoader>
      ) : (
        stepInfo === 0 && IMOB_SEGMENT
          ? (
            <>
              <ContentText>
                Detalhe a forma de desconto no repasse ao proprietário adicionando parcelas e juros se aplicável:
              </ContentText>
              <TextAreaStyled
                value={fields.notes}
                name="notes"
                onChange={changeField}
                placeholder="Observações sobre o pagamento"
              />
            </>
          )
          : (
            <>
              <ContentText>
                Por favor, selecione para quem serão emitidas a Nota Fiscal e o Boleto, e insira suas
                informações:
              </ContentText>
              <SelectButtons>
                {billingTypes.map(
                  type => !type.hide && (
                  <Button
                    key={type.text}
                    onClick={() => selectBillingType(type.text)}
                    className={type.text === billingType ? 'active' : ''}
                  >
                    {type.text}
                  </Button>
                  ),
                )}
              </SelectButtons>
              <PaymentInfo>
                <InputText
                  placeholder="Nome:"
                  type="text"
                  name="name"
                  value={fields.name}
                  onChange={changeField}
                />
                <InputText
                  placeholder="Email:"
                  type="email"
                  name="email"
                  value={fields.email}
                  onChange={changeField}
                />
                <InputText
                  placeholder="CPF ou CNPJ:"
                  type="text"
                  name="cpfCnpj"
                  value={
                fields.cpf && fields.cpf.length > 0
                  ? setCPFMask(fields.cpf)
                  : setCNPJMask(fields.cnpj)
              }
                  onChange={changeFieldCpfCnpj}
                />

                <>
                  <InputText
                    placeholder="CEP:"
                    disabled={disabledInputForBuilding}
                    type="text"
                    name="cep"
                    value={setCEPMask(fields.cep)}
                    onChange={changeFieldCep}
                    onBlur={e => searchCEP(e.target.value)}
                  />
                  <InputText
                    disabled={disabledInputForBuilding}
                    placeholder="Número:"
                    type="number"
                    name="number"
                    value={fields.number}
                    onChange={changeField}
                  />
                  <InputText
                    placeholder="Complemento:"
                    disabled={disabledInputForBuilding}
                    type="text"
                    name="address_details"
                    value={fields.address_details}
                    onChange={changeField}
                  />
                </>

              </PaymentInfo>
            </>
          )
      )}
    </Content>
  );
};

export default PaymentInfoStep;
